import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import RoleSelection from "@/pages/RoleSelection";
import CashierScreen from "@/pages/CashierScreen";
import SupervisorScreen from "@/pages/SupervisorScreen";

function App() {
  return (
    <div className="app-container" dir="rtl">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RoleSelection />} />
          <Route path="/cashier/:cashNumber" element={<CashierScreen />} />
          <Route path="/supervisor" element={<SupervisorScreen />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
